import type { SVGProps } from 'react';

/** Press release badge — `fa/megaphone` in the design. */
export function IconMegaphone(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M21.0625 3C21.5703 3 22 3.44196 22 3.96429V20.0357C22 20.558 21.5703 21 21.0625 21C20.5547 21 20.125 20.558 20.125 20.0357V19.5134L14.4219 17.8661C14.1094 19.6339 12.5859 21 10.75 21C8.67969 21 7 19.2723 7 17.1429C7 16.6607 7.07812 16.1786 7.23437 15.7768L3.875 14.8125V14.8929C3.875 15.4152 3.44531 15.8571 2.9375 15.8571C2.42969 15.8571 2 15.4152 2 14.8929V9.10714C2 8.58482 2.42969 8.14286 2.9375 8.14286C3.44531 8.14286 3.875 8.58482 3.875 9.10714V9.22768L20.125 4.52679V3.96429C20.125 3.44196 20.5547 3 21.0625 3ZM20.125 17.5045V6.49554L3.875 11.1964V12.8036L20.125 17.5045ZM12.625 17.3036V17.3438L9.07031 16.2991C8.95312 16.5402 8.875 16.8214 8.875 17.1429C8.875 18.2277 9.73437 19.0714 10.75 19.0714C11.7266 19.0714 12.5469 18.308 12.625 17.3036Z"
                fill="currentColor"
            />
        </svg>
    );
}
